exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--1eKJB .formatted--3rCLs {\n  font-weight: 400;\n}\n\n.wrapper--1eKJB .text--2qrZ3 {\n  font-size: 12px;\n  color: #878787;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--1eKJB",
	"formatted": "formatted--3rCLs",
	"text": "text--2qrZ3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/utils/HumanReadableDate/HumanReadableDate.m.scss
// module id = 1523
// module chunks = 0